import {createReducer, on} from '@ngrx/store';
import {DomainItem} from '../../../models/domain-item';
import {
  loadDomainItemsFailedAction,
  loadDomainItemsStartAction,
  loadDomainItemsSucceededAction, updateDomainsWithIsWorkflowSucceedAction
} from '../action/domain.action';
import * as _ from 'lodash';

export interface DomainState {
  datas: DomainItem[];
  loading: boolean;
  error: any;
}

export const DOMAIN_INITIAL_STATE: DomainState = {
  datas: [],
  loading: false,
  error: null
};

export const domainReducer = createReducer(DOMAIN_INITIAL_STATE,
  on(loadDomainItemsStartAction, state => ({
    ...state,
    test: '',
    loading: true,
    error: null,
  })),
  on(loadDomainItemsSucceededAction, (state, action) => ({
    ...state,
    datas: [...action.payload],
    test: '',
    loading: false,
    error: null,
  })),
  on(loadDomainItemsFailedAction, (state, action) => ({
    ...state,
    datas: [],
    test: '',
    loading: false,
    error: action.error,
  })),
  on(updateDomainsWithIsWorkflowSucceedAction, (state, action) => {
    const datasCopy = _.cloneDeep(state.datas);
    const domainWkfcodes = action.payload.map( (domainWkf) => domainWkf.code)
    datasCopy.map( (domainItem) => { if (domainWkfcodes.includes(domainItem.code) ) { domainItem.isWorkflow = true;} } )
    return {
      ...state,
      datas: datasCopy,
      test: '',
      loading: false,
      error: null,
    };
  }),
)
